import { render, staticRenderFns } from "./application_announcement_product_appendix1_2.vue?vue&type=template&id=13c0d761&scoped=true"
import script from "./application_announcement_product_appendix1_2.vue?vue&type=script&lang=js"
export * from "./application_announcement_product_appendix1_2.vue?vue&type=script&lang=js"
import style0 from "./application_announcement_product_appendix1_2.vue?vue&type=style&index=0&id=13c0d761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c0d761",
  null
  
)

export default component.exports